import styled, { css } from 'styled-components';
import { device } from '../../../styles/devices';
import type { ThemeProps } from '../../../types';

interface ContainerProps {
  used?: boolean;
  fallback?: boolean;
  nonAudi?: boolean;
  hasDealerImages?: boolean;
}

export const Container = styled.div<ContainerProps>`
  position: relative;
  display: flex;
  margin: ${({ used, nonAudi, fallback }) =>
    used || nonAudi || fallback ? '20px 18px 46px ' : '84px 0'};
  justify-content: space-between;

  @media (min-width: 600px) {
    margin: ${({ used, nonAudi, fallback }) =>
      used || nonAudi || fallback ? '20px 18px 46px ' : '46px 0'};
  }

  @media ${device.tablet} {
    margin: ${({ used, nonAudi, fallback }) =>
      used || nonAudi || fallback ? 'calc(75% + 18px) 0 46px 0' : '46px 0'};
    right: ${({ used, nonAudi, fallback }) => (used || nonAudi || fallback ? '60px' : '45px')};
    position: absolute;
    top: 9px;
    margin: 0;
    flex-direction: column;
  }
  @media ${device.laptopM} {
    right: ${({ used, nonAudi, fallback }) => (used || nonAudi || fallback ? '-156px' : '45px')};
    top: 0;
    margin: 0;
    ${(props: { fallback?: boolean | undefined }) => {
      if (props.fallback)
        return css`
          padding-bottom: 0px;
          right: 40px;
        `;
      return css``;
    }}
  }
  @media ${device.laptopL} {
    right: ${({ used, nonAudi }) => (used || nonAudi ? '-145px' : '45px')};
    ${({ used, nonAudi, hasDealerImages }) => {
      if (!used && hasDealerImages)
        return css`
          right: 0;
        `;
      if (used || nonAudi)
        return css`
          right: -145px;
        `;
      return css`
        right: 45px;
      `;
    }}
    ${(props: { fallback?: boolean | undefined }) => {
      if (props.fallback)
        return css`
          right: 40px;
        `;
      return css``;
    }}
  }
  @media ${device.laptopXL} {
    ${({ used, nonAudi, fallback, hasDealerImages }) => {
      if (!used && hasDealerImages)
        return css`
          right: 0;
        `;
      if (used || nonAudi || fallback)
        return css`
          right: -100px;
        `;
      return css`
        right: 45px;
      `;
    }}
    ${(props: { fallback?: boolean | undefined }) => {
      if (props.fallback)
        return css`
          right: 40px;
        `;
      return css``;
    }}
  }
`;

export const Result = styled.div`
  margin: 0px 10px;
`;

export const ImageButton = styled.button<ContainerProps>`
  height: auto;
  width: ${({ used, nonAudi, fallback }) =>
    used || nonAudi || fallback ? 'calc((100% / 4) - 18px)' : 'calc(100% / 4)'};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  @media ${device.tablet} {
    height: auto;
    width: auto;
    padding-bottom: ${({ used, nonAudi, fallback }) => (used || nonAudi || fallback ? '9px' : '0')};
  }
  span {
    height: 80px;
    width: fill-available;
    margin: 0px 9px;
  }
  @media ${device.tablet} {
    span {
      height: calc(403px / 5);
      width: 112px;
      margin: 1px 0px;
    }
  }
  @media ${device.laptop} {
    span {
      height: calc(503px / 5);
      width: 150px;
      margin: 0px 0px 1px 0px;
    }
  }
`;

export const Image = styled.img`
  height: 100%;
  width: 100%;
  @media ${device.tablet} {
    max-height: calc(403px / 5);
    width: auto;
    max-width: 112px;
  }
  @media ${device.laptop} {
    max-height: calc(503px / 5);
    width: auto;
    max-width: 150px;
  }
`;

export const MoreImages = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: transparent;
  margin-top: 20px;
  font-family: 'Audi Type';
  font-size: 13px;
  line-height: 18px;
  border: none;
  cursor: pointer;
  @media ${device.tablet} {
    margin-top: 0px;
  }
`;

export const IconContainer = styled.div`
  display: grid;
  transform: ${(props: { modal?: boolean }) => (props.modal ? null : 'rotate(45deg)')};
  margin-bottom: 11px;
  border: 1px solid ${(props: { theme: ThemeProps }) => props.theme.sys.color.surface.neutral[100]};
  border-radius: 50%;
`;
